import Vue from 'vue';
import { Input, Menu, Icon, Pagination,
  message, Spin, Modal, Form, Button } from 'ant-design-vue';
import Index from './index.vue';
import 'babel-polyfill';
// import 'babel-polyfill'
/* eslint-disable no-new */

Vue.use(Input)
  .use(Menu)
  .use(Icon)
  .use(Pagination)
  .use(Spin)
  .use(Modal)
  .use(Form)
  .use(Button);
Vue.prototype.$message = message;
new Vue({
  el: '#app',
  components: { Index },
  template: '<Index />'
});



// WEBPACK FOOTER //
// ./src/pages/index/index.js